const ENVIRONMENTS = [
  "prod",
  "staging1",
  "staging2",
  "demo",
  "local",
  "__test__"
] as const;
export type Environment = typeof ENVIRONMENTS[number];

export function isValidEnvironment(env: string): env is Environment {
  return (ENVIRONMENTS as readonly string[]).includes(env);
}
